"use client";

import React, { useState } from "react";
import Search from "lucide-react/dist/esm/icons/search";
import { Input } from "../../components/ui/input";
import { cn } from "../../lib/utils";
import SearchIcon from "@mui/icons-material/Search";

export function SearchInput({ className, onSearch, placeholder = "Toll Name", ...props }) {
  const [value, setValue] = useState("");

  const handleChange = (e) => {
    const newValue = e.target.value;
    setValue(newValue);
    if (onSearch) {
      onSearch(newValue);
    }
  };

  return (
    <div className={cn("relative", className)}>
      <SearchIcon className="absolute left-2.5 top-2.5 h-4 w-4 text-gray-400" />
      <Input
        className="pl-10 h-[40px] bg-[#F4F4F4] rounded-[8px] shadow-none flex items-center border-0 text-gray-400 text-base"
        type="search"
        placeholder={`Search by ${placeholder}`}
        value={value}
        onChange={handleChange}
        {...props}
      />
    </div>
  );
}
